import { Box } from "@mui/material";
import Icon from "components/icons/Icon";
import Text from "components/labels/Text";

const MyListItem = (props: any) => {
    const {children, icon, alignItems, ...rest} = props;
    const align = alignItems ?? 'start'
    const title = rest.title ? <Text>{rest.title}</Text> : children;
    const iconFinal = icon ? icon : <Icon verySmall>circle</Icon>;
    return(
        <Box display='flex' alignItems={align}>
            <Box mt={align == 'start' ? "2px": 0}>{iconFinal}</Box>
            <Box ml={1}>{title}</Box>
        </Box>

    )

}

export default MyListItem;
